import { render, staticRenderFns } from "./About.vue?vue&type=template&id=736d0008&scoped=true&"
var script = {}
import style0 from "./About.vue?vue&type=style&index=0&id=736d0008&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "736d0008",
  null
  
)

component.options.__file = "About.vue"
export default component.exports